var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "maintenanceModeSetting" } }, [
    _c("div", { staticClass: "maintenance-container" }, [
      _c("div", { staticClass: "d-flex" }, [
        _c("div", { staticClass: "title heading-3" }, [
          _vm._v("Maintenance Period")
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn-add text-information",
            on: { click: _vm.openAdd }
          },
          [_vm._v("+ Add")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "search-data" }, [
          _c("i", { staticClass: "fa fa-search" }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.search,
                expression: "search"
              }
            ],
            attrs: { type: "text", placeholder: "Search..." },
            domProps: { value: _vm.search },
            on: {
              keypress: function($event) {
                if (!("button" in $event) && $event.keyCode !== 13) {
                  return null
                }
                $event.preventDefault()
                _vm.handleSearch($event)
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.search = $event.target.value
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      !_vm.loadingFirst && _vm.maintenanceList && _vm.maintenanceList.length > 0
        ? _c(
            "div",
            { staticClass: "maintenance-overflow-list" },
            _vm._l(_vm.maintenanceList, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "maintenance-list" },
                [
                  _vm.getStatus(item.status)
                    ? _c(
                        "div",
                        {
                          class:
                            "block-status heading-5 " +
                            (item.status ? item.status.toLowerCase() : "")
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(item.status) + "\n        "
                          )
                        ]
                      )
                    : _c("div", { class: "block-status heading-5 unknown" }, [
                        _vm._v("\n          unknown\n        ")
                      ]),
                  _vm._v(" "),
                  item.level === "application" || item.level === "page"
                    ? _c("img", {
                        staticClass: "m__l--10 m__t--1",
                        attrs: {
                          src: require("@/assets/icon/level-" +
                            item.level +
                            ".svg"),
                          width: "15",
                          height: "15"
                        }
                      })
                    : _c("img", {
                        staticClass: "m__l--10 m__t--1",
                        attrs: {
                          src: require("@/assets/icon/level-application.svg"),
                          width: "15",
                          height: "15"
                        }
                      }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "title-list ellipsis heading-5 m__l--10" },
                    [_vm._v(_vm._s(item.title || "-"))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "date-list text-information" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          item.start_period
                            ? _vm
                                .$moment(new Date(item.start_period))
                                .format("DD MMMM YYYY HH:mm:ss")
                            : ""
                        ) +
                        " -\n          " +
                        _vm._s(
                          item.end_period
                            ? _vm
                                .$moment(new Date(item.end_period))
                                .format("DD MMMM YYYY HH:mm:ss")
                            : ""
                        ) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "config-list" }, [
                    _c("img", {
                      staticClass: "cursor-pointer m__l--10",
                      attrs: {
                        src: require("@/assets/automation/config.svg"),
                        width: "15",
                        height: "15"
                      },
                      on: {
                        click: function($event) {
                          _vm.openDetail(item, index)
                        }
                      }
                    })
                  ])
                ]
              )
            })
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loadingFirst &&
      _vm.maintenanceList &&
      _vm.maintenanceList.length === 0
        ? _c("div", { staticClass: "maintenance-no-data" }, [
            _vm._v("\n      No Data\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loadingFirst
        ? _c(
            "div",
            { staticClass: "m__t--10" },
            _vm._l(5, function(i) {
              return _c("div", { key: i, staticClass: "skeleton" })
            })
          )
        : _vm._e(),
      _vm._v(" "),
      (!_vm.loadingFirst &&
        _vm.maintenanceList && _vm.maintenanceList.length > 0) ||
      (_vm.maintenanceList && _vm.pageData > 1)
        ? _c("div", { staticClass: "custom-pagination" }, [
            _c(
              "div",
              { staticClass: "btn-previous", on: { click: _vm.previousPage } },
              [_c("i", { staticClass: "fa fa-chevron-left" })]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btn-forward", on: { click: _vm.forwardPage } },
              [_c("i", { staticClass: "fa fa-chevron-right" })]
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-properties-automation",
        class: {
          "show-container-properties-automation": _vm.showProperties,
          "hide-container-properties-automation": !_vm.showProperties
        }
      },
      [
        _c(
          "div",
          { staticClass: "d-flex align-items-start justify-content-between" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "close-properties-automation",
                on: { click: _vm.hideProperties }
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/icon/icon-close-properties.svg"),
                    width: "25"
                  }
                })
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "privilege-data-manager-access" },
          [
            _c("div", { staticClass: "heading-4" }, [_vm._v("General")]),
            _vm._v(" "),
            _c(
              "b-form-group",
              { class: { "error-input": _vm.$v.dataMaintenance.title.$error } },
              [
                _c("label", [_vm._v(" Title ")]),
                _vm._v(" "),
                _c("j-input", {
                  attrs: {
                    "error-required": false,
                    disabled: _vm.isDisabled,
                    placeholder: "Input Title"
                  },
                  model: {
                    value: _vm.$v.dataMaintenance.title.$model,
                    callback: function($$v) {
                      _vm.$set(_vm.$v.dataMaintenance.title, "$model", $$v)
                    },
                    expression: "$v.dataMaintenance.title.$model"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "6" } },
                  [
                    _c(
                      "b-form-group",
                      {
                        class: {
                          "error-input":
                            _vm.$v.dataMaintenance.start_period.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Start Period ")]),
                        _vm._v(" "),
                        _c("j-date-time", {
                          attrs: {
                            type: "datetime",
                            data: _vm.dataMaintenance.start_period,
                            "error-required": false,
                            "min-datetime": _vm.getDateToday(),
                            "max-datetime": _vm.dataMaintenance.end_period
                              ? _vm.getDateEndPeriode()
                              : null,
                            disabled: _vm.isDisabled,
                            placeholder: "Enter Start Period",
                            format: "MMM dd, yyyy, HH:mm"
                          },
                          on: { getTimestamp: _vm.setValueStartPeriode }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { md: "6" } },
                  [
                    _c(
                      "b-form-group",
                      {
                        class: {
                          "error-input":
                            _vm.$v.dataMaintenance.end_period.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" End Period ")]),
                        _vm._v(" "),
                        _c("j-date-time", {
                          attrs: {
                            type: "datetime",
                            data: _vm.dataMaintenance.end_period,
                            "error-required": false,
                            "min-datetime": _vm.dataMaintenance.start_period
                              ? _vm.getDateStartPeriode()
                              : _vm.getDateToday(),
                            disabled: _vm.isDisabled,
                            placeholder: "Enter End Period",
                            format: "MMM dd, yyyy, HH:mm"
                          },
                          on: { getTimestamp: _vm.setValueEndPeriode }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "privilege-data-manager-access",
            class: { "error-input": _vm.$v.dataMaintenance.level.$error }
          },
          [
            _c("div", { staticClass: "heading-4" }, [_vm._v("Level")]),
            _vm._v(" "),
            _c("div", { staticClass: "text-information" }, [
              _vm._v("Level of maintenance for this period")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex m__t--10" }, [
              _c(
                "div",
                {
                  staticClass: "level-maintenance",
                  class: {
                    active: _vm.dataMaintenance.level === "application"
                  },
                  on: {
                    click: function($event) {
                      _vm.changeLevel("application")
                    }
                  }
                },
                [_vm._v("\n          Application\n        ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "level-maintenance",
                  class: { active: _vm.dataMaintenance.level === "page" },
                  on: {
                    click: function($event) {
                      _vm.changeLevel("page")
                    }
                  }
                },
                [_vm._v("\n          Page\n        ")]
              )
            ]),
            _vm._v(" "),
            _vm.dataMaintenance.level === "page" &&
            _vm.listPages &&
            _vm.listPages.length > 0
              ? _c(
                  "div",
                  { staticClass: "maintenance-pages-container" },
                  _vm._l(_vm.isParent, function(valParent) {
                    return _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              valParent.type === "visible" ||
                              _vm.getSubPageByParent(valParent.id).length > 0,
                            expression:
                              "valParent.type === 'visible' || getSubPageByParent(valParent.id).length > 0"
                          }
                        ],
                        key: valParent.id,
                        staticClass: "list-pages"
                      },
                      [
                        _c(
                          "b-row",
                          { staticClass: "pr-2" },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "information",
                                attrs: { cols: "10" }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: valParent.icon_grey,
                                    height: "16",
                                    width: "16"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "heading-4 m__l--10" },
                                  [_vm._v(_vm._s(valParent.name.toUpperCase()))]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            valParent.type === "visible"
                              ? _c(
                                  "b-col",
                                  { attrs: { cols: "2" } },
                                  [
                                    _c("j-toggle", {
                                      staticClass: "m__l--5",
                                      attrs: { disabled: _vm.isDisabled },
                                      model: {
                                        value: valParent.active_mode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            valParent,
                                            "active_mode",
                                            $$v
                                          )
                                        },
                                        expression: "valParent.active_mode"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.getSubPageByParent(valParent.id), function(
                          valChild
                        ) {
                          return _c(
                            "div",
                            {
                              key: valChild.id,
                              staticClass: "list-page-child"
                            },
                            [
                              _c(
                                "b-row",
                                { staticClass: "pr-2" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "information",
                                      attrs: { cols: "10" }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: valChild.icon_grey,
                                          height: "16",
                                          width: "16"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "heading-4 m__l--10" },
                                        [
                                          _vm._v(
                                            _vm._s(valChild.name.toUpperCase())
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "2" } },
                                    [
                                      _c("j-toggle", {
                                        attrs: { disabled: _vm.isDisabled },
                                        model: {
                                          value: valChild.active_mode,
                                          callback: function($$v) {
                                            _vm.$set(
                                              valChild,
                                              "active_mode",
                                              $$v
                                            )
                                          },
                                          expression: "valChild.active_mode"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  })
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "heading-3" }, [_vm._v("Configuration")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "privilege-data-manager-access m__t--10" },
          [
            _c("div", { staticClass: "d-flex" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "privilege-data-manager-access-toggle" },
                [
                  _c("j-toggle", {
                    staticClass: "m__t--12",
                    attrs: { disabled: _vm.isDisabled },
                    model: {
                      value: _vm.dataMaintenance.is_use_custom_message,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.dataMaintenance,
                          "is_use_custom_message",
                          $$v
                        )
                      },
                      expression: "dataMaintenance.is_use_custom_message"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.dataMaintenance.is_use_custom_message,
                    expression: "dataMaintenance.is_use_custom_message"
                  }
                ],
                class: {
                  "error-input": _vm.$v.dataMaintenance.custom_message.$error
                }
              },
              [
                _c("label", [_vm._v(" Title ")]),
                _vm._v(" "),
                _c("j-textarea", {
                  attrs: {
                    "error-required": false,
                    "max-length": 300,
                    disabled: _vm.isDisabled,
                    placeholder: "Type custom message"
                  },
                  model: {
                    value: _vm.$v.dataMaintenance.custom_message.$model,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.$v.dataMaintenance.custom_message,
                        "$model",
                        $$v
                      )
                    },
                    expression: "$v.dataMaintenance.custom_message.$model"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "privilege-data-manager-access m__t--10",
            class: {
              "error-input":
                _vm.dataMaintenance.is_use_user_exception &&
                _vm.dataUserOrganigram.length === 0 &&
                _vm.$v.dataMaintenance.user_organigram_exception.$error
            }
          },
          [
            _c("div", { staticClass: "d-flex" }, [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "privilege-data-manager-access-toggle" },
                [
                  _c("j-toggle", {
                    staticClass: "m__t--12",
                    attrs: { disabled: _vm.isDisabled },
                    model: {
                      value: _vm.dataMaintenance.is_use_user_exception,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.dataMaintenance,
                          "is_use_user_exception",
                          $$v
                        )
                      },
                      expression: "dataMaintenance.is_use_user_exception"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.dataMaintenance.is_use_user_exception,
                    expression: "dataMaintenance.is_use_user_exception"
                  }
                ]
              },
              [
                _vm.isShowModalOrganigram
                  ? _c(
                      "div",
                      { staticClass: "modal-organigram" },
                      [
                        _c("div", { staticClass: "heading-2" }, [
                          _vm._v("Add Position")
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            class: {
                              "error-input": _vm.$v.userOrganigram.$error
                            }
                          },
                          [
                            _c("label", [_vm._v("Position")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                custom: true,
                                "is-async": true,
                                "cache-options": false,
                                "load-options": _vm.loadUserOptions,
                                placeholder: "Select Position",
                                "value-format": "object",
                                label: "name"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "node-custom",
                                  fn: function(node) {
                                    return [
                                      _c("div", { staticClass: "d-flex" }, [
                                        _c(
                                          "div",
                                          { staticClass: "m__r--7" },
                                          [
                                            node.node.raw.user &&
                                            node.node.raw.user.profile &&
                                            node.node.raw.user.profile.photo_url
                                              ? _c("b-img", {
                                                  staticClass:
                                                    "m-1 round-bordered-img\n                      img-circle staff-img image-popup-link b-page-theme td",
                                                  attrs: {
                                                    src:
                                                      node.node.raw.user.profile
                                                        .photo_url,
                                                    rounded: "circle",
                                                    alt: "img"
                                                  }
                                                })
                                              : _c("b-img", {
                                                  staticClass:
                                                    "m-1 round-bordered-img\n                      img-circle staff-img image-popup-link b-page-theme td",
                                                  attrs: {
                                                    src: require("@/assets/logo/user1.png"),
                                                    rounded: "circle",
                                                    alt: "img"
                                                  }
                                                })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        node.node.raw.user &&
                                        node.node.raw.user.profile
                                          ? _c(
                                              "div",
                                              { staticClass: "m__t--5" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "privilege-user-info-fullname"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(node.node.raw.id) +
                                                        " - " +
                                                        _vm._s(
                                                          node.node.raw.name
                                                        )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "privilege-user-info-email"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        node.node.raw.user
                                                          .profile.first_name
                                                      ) +
                                                        " " +
                                                        _vm._s(
                                                          node.node.raw.user
                                                            .profile.last_name
                                                        )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "privilege-user-info-email"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        node.node.raw.user
                                                          .profile.email
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              { staticClass: "m__t--5" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "privilege-user-info-fullname"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(node.node.raw.id) +
                                                        " - " +
                                                        _vm._s(
                                                          node.node.raw.name
                                                        )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "privilege-user-info-email"
                                                  },
                                                  [_vm._v("No User")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "privilege-user-info-email"
                                                  },
                                                  [_vm._v("-")]
                                                )
                                              ]
                                            )
                                      ])
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.$v.userOrganigram.$model,
                                callback: function($$v) {
                                  _vm.$set(_vm.$v.userOrganigram, "$model", $$v)
                                },
                                expression: "$v.userOrganigram.$model"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-end mt-2" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "button-border mr-2",
                                on: { click: _vm.closeModalOrganigram }
                              },
                              [_vm._v("\n              Close\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "button-blue",
                                on: { click: _vm.submitOrganigram }
                              },
                              [_vm._v("\n              Add\n            ")]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.dataUserOrganigram, function(item, index) {
                  return _c("div", { key: index, staticClass: "m__t--20" }, [
                    _c("div", { staticClass: "d-flex" }, [
                      _c(
                        "div",
                        { staticClass: "m__r--7 p__t--3" },
                        [
                          item.user &&
                          item.user.profile &&
                          item.user.profile.photo_url
                            ? _c("b-img", {
                                staticClass:
                                  "m-1 round-bordered-img\n                img-circle staff-img image-popup-link b-page-theme td",
                                attrs: {
                                  src: item.user.profile.photo_url,
                                  rounded: "circle",
                                  alt: "img"
                                }
                              })
                            : _c("b-img", {
                                staticClass:
                                  "m-1 round-bordered-img\n                img-circle staff-img image-popup-link b-page-theme td",
                                attrs: {
                                  src: require("@/assets/logo/user1.png"),
                                  rounded: "circle",
                                  alt: "img"
                                }
                              })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      item.user && item.user.profile
                        ? _c(
                            "div",
                            { staticClass: "info-organigram m__t--5" },
                            [
                              _c(
                                "div",
                                { staticClass: "privilege-user-info-fullname" },
                                [
                                  _vm._v(
                                    _vm._s(item.id) + " - " + _vm._s(item.name)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "privilege-user-info-email" },
                                [
                                  _vm._v(
                                    _vm._s(item.user.profile.first_name) +
                                      " " +
                                      _vm._s(item.user.profile.last_name)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "privilege-user-info-email" },
                                [_vm._v(_vm._s(item.user.profile.email))]
                              )
                            ]
                          )
                        : _c(
                            "div",
                            { staticClass: "info-organigram m__t--5" },
                            [
                              _c(
                                "div",
                                { staticClass: "privilege-user-info-fullname" },
                                [
                                  _vm._v(
                                    _vm._s(item.id) + " - " + _vm._s(item.name)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "privilege-user-info-email" },
                                [_vm._v("No User")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "privilege-user-info-email" },
                                [_vm._v("-")]
                              )
                            ]
                          ),
                      _vm._v(" "),
                      !_vm.isDisabled
                        ? _c("div", { staticClass: "btn-remove-org" }, [
                            _c("i", {
                              staticClass: "fa fa-trash cursor-pointer",
                              on: {
                                click: function($event) {
                                  _vm.removeOrganigram(index)
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  ])
                }),
                _vm._v(" "),
                !_vm.isDisabled
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "text-information cursor-pointer add-suer m__t--10",
                        on: { click: _vm.showModalOrganigram }
                      },
                      [_vm._v("+ Add Position")]
                    )
                  : _vm._e()
              ],
              2
            )
          ]
        ),
        _vm._v(" "),
        _vm.dataEdit && !_vm.isDisabled
          ? _c(
              "div",
              { staticClass: "privilege-data-manager-access m__t--10" },
              [
                _c("div", { staticClass: "heading-4" }, [
                  _vm._v("Force Terminate Maintenance")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-information" }, [
                  _vm._v("The maintenance process ends early")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn-terminate",
                    on: { click: _vm.terminateMaintenanceMode }
                  },
                  [_vm._v("Terminate")]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "privilege-data-manager-access-button",
            class: {
              "show-privilege-data-manager-access-button": _vm.showProperties,
              "hide-privilege-data-manager-access-button": !_vm.showProperties
            }
          },
          [
            _c(
              "button",
              {
                class:
                  "button-border " +
                  (_vm.isDisabled ? "close-prop" : "close-prop-2"),
                on: { click: _vm.hideProperties }
              },
              [_vm._v("\n        Close\n      ")]
            ),
            _vm._v(" "),
            !_vm.isDisabled
              ? _c(
                  "button",
                  {
                    staticClass: "button-border submit-prop",
                    on: { click: _vm.submitMaintenanceMode }
                  },
                  [_vm._v("\n        Apply\n      ")]
                )
              : _vm._e()
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label-log-detail" }, [
      _vm._v("\n        Properties\n        "),
      _c("span", [_vm._v("Maintenance Mode")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "custom-message" }, [
      _c("div", { staticClass: "heading-4" }, [_vm._v("Custom Message")]),
      _vm._v(" "),
      _c("div", { staticClass: "text-information" }, [
        _vm._v(
          "Enter your custom message in the text box to display a popup warning when a user clicks on this application or this page"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "custom-message" }, [
      _c("div", { staticClass: "heading-4" }, [_vm._v("Position Exception")]),
      _vm._v(" "),
      _c("div", { staticClass: "text-information" }, [
        _vm._v(
          "specify which position should not be placed in maintenance mode"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ffc558a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ffc558a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/access/tab/jAccessApplicationTabMaintenance.vue
// module id = null
// module chunks = 